<template>
  <v-app>
    <!-- Barra superior -->
    <!--  escucha del evento y pone si esta bierto o cerrado -->
    <NavBar @toggle-drawer="drawer = !drawer" />
    <!-- Navegador lateral -->
    <DashNavigatorAdmin v-if="isAdmin" v-model="drawer" :nombre="username" />
    <DashNavigator v-else v-model="drawer" :nombre="username" />

    <!-- Contenido principal -->

    <v-main class="d-flex flex-column">
      <!-- El contenido crece y empuja el footer al fondo de la pantalla -->
      <div class="flex-grow-1">
        <router-view />
      </div>

      <FooterMain />
    </v-main>

    <!-- Diálogo de sesión expirada -->
    <v-dialog v-model="showAlertExpire" max-width="500" persistent>
      <v-card>
        <v-card-title
          class="headline"
          style="background-color: #005fa9; color: white"
        >
          ⚠️ {{ $t("session_expiring_title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("session_expiring_message") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="refreshToken" v-if="canRefresh">
            {{ $t("extend_session") }}
          </v-btn>
          <v-btn text @click="showAlertExpire = false">{{
            $t("cerrar")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import api from "@/api/axios/axios.js";
import NavBar from "@/components/Global/NavBar.vue";
import DashNavigator from "@/components/Global/DashNavigator.vue";
import DashNavigatorAdmin from "@/components/Global/DashNavigatorAdmin.vue";
import FooterMain from "@/components/Global/Footer.vue";
import { useAuthStore } from "@/stores/auth";

// eslint-disable-next-line no-undef

export default {
  name: "dashboardPage",
  components: {
    NavBar,
    DashNavigator,
    DashNavigatorAdmin,
    FooterMain,
  },
  data() {
    return {
      drawer: false,
      username: "",
      showAlertExpire: false,
      token: "",
      tokenExpirationInterval: null,
      canRefresh: true,
      tokenExpirationTimeout: null,
    };
  },
  created() {
    this.viewProtectedDashboard();
    this.setupTokenExpirationWatcher();
    // Rol fresco desde el backend (no confiamos en localStorage viejo).
    useAuthStore()
      .fetchRole()
      .catch(() => {
        /* el interceptor 401 ya redirige si no hay sesion */
      });
  },
  computed: {
    isAdmin() {
      // Fuente de verdad: el store (rol traido del backend). Reactivo:
      // al cambiar de usuario/rol, el navigator se actualiza solo.
      return useAuthStore().canAdminAccess;
    },
  },
  methods: {
    async viewProtectedDashboard() {
      try {
        const response = await api.get("login/protected/");

        this.username = response.data.user;
      } catch (error) {
        if (error.response.status === 401) {
          this.$router.push("/index");
        }
      }
    },

    setupTokenExpirationWatcher() {
      // Limpiar timeouts anteriores si existen
      if (this.tokenExpirationTimeout) {
        clearTimeout(this.tokenExpirationTimeout);
        this.tokenExpirationTimeout = null;
      }
      const exp = localStorage.getItem("token_exp");

      if (exp) {
        const expTimeMs = parseInt(exp) * 1000; // timestamp en ms
        const now = Date.now();
        const timeLeft = expTimeMs - now;
        this.canRefresh = true;

        // Mostrar alerta 1 minuto antes de la expiración
        if (timeLeft <= 60000) {
          this.showAlertExpire = true;
        } else {
          setTimeout(() => {
            this.showAlertExpire = true;
          }, timeLeft - 60000);
        }

        // Redirigir al expirar el token
        this.tokenExpirationTimeout = setTimeout(() => {
          //console.log("🔒 Token expirado. Redirigiendo a /index...");
          this.$router.push({
            path: "/index",
            query: { error: "session_expired" },
          });
        }, timeLeft);
      }
    },
    // Método para refrescar el token
    async refreshToken() {
      try {
        const response = await api.post("login/token/refresh/"); // Solicitar el nuevo token
        const newAccessToken = response.data.access;
        //console.log("Tokennn"+ newAccessToken)
        // Guardar el nuevo token en localStorage
        localStorage.setItem("access_token", newAccessToken);

        // Decodificar el nuevo token para obtener su fecha de expiración
        const decodedToken = JSON.parse(atob(newAccessToken.split(".")[1]));

        localStorage.setItem("token_exp", decodedToken.exp);
        // const expTimestamp = response // ⏰ viene del backend

        // Restablecer los estados
        this.showAlertExpire = false;
        this.canRefresh = false;
        //console.log('Token refrescado con éxito!');

        // Reconfigurar el observador de expiración
        this.setupTokenExpirationWatcher();
      } catch (error) {
        console.error("Error al refrescar el token", error);
        this.$router.push("/index"); // Redirigir al login si algo sale mal
      }
    },
  },
};
</script>

<style scoped>
/* v-main llena la pantalla MENOS el alto del NavBar (64px), así el footer
   queda al fondo sin generar scroll de más. */
:deep(.v-main) {
  min-height: calc(100vh - 64px);
}
</style>
